import { HorizontalBarGraph } from "../../Charts/HorizontalBarGraph/HorizontalBarGraph";
import { BlankState } from "../BotAnalyticsDashboard";
import { Spinner } from "@swivl-mono/ui";

export const PayBill = ({payBillData, colors}) => {
    let content, total, viewAll;
    if (payBillData) {
      if (Array.isArray(payBillData) && payBillData.length > 0) {
        const started = payBillData.find((item) => item.title === "Pay Bill Start");
        total = started ? started.value.toLocaleString() : "0";
        const data = payBillData
          .sort((a, b) => b.value - a.value)
          .filter((item) => item.title !== "Pay Bill Start")
          .map((item, index) => ({
            title: `${item.title} - ${Math.round((item.value / total) * 100)}%`,
            rows: [{ value: item.value, color: colors[index % colors.length] }],
            total: item.value,
          }));
        content = (
          <div className="barAndPieWapper">
            <HorizontalBarGraph data={data} showTotals={true} />
          </div>
        );
        // viewAll = <a className="viewAll" onClick={() => this.setState({ showAllCortexes: true })}>VIEW ALL</a>;
      } else {
        content = <div className="loadingContent">{BlankState()}</div>;
      }
    } else {
      content = (
        <div className="loadingContent">
          <Spinner />
        </div>
      );
    }
    return (
      <div className="chartBox">
        <div className="chartHeader">
          <div className="chartHeaderTitle">
            <span>Payment Assistance</span>
          </div>
          <div className="spacer" />
          <div className="headerTotal">{total}</div>
        </div>
        <div className="chartContent">{content}</div>
        {viewAll}
      </div>
    );
  }